import * as z from "zod/v4";

export const getJudgeMeIntegration = {
  name: "getJudgeMeIntegration" as const,
  input: z.object({}),
  output: z.object({
    judgeMeIntegration: z
      .object({ shopDomain: z.string(), enabled: z.boolean() })
      .optional(),
  }),
};

export type JudgeMeIntegrationDto = z.infer<
  typeof getJudgeMeIntegration.output
>["judgeMeIntegration"];
